import { useLocation } from "react-router";

export type PrevPage = {
	url: string;
	label: string;
};

export function usePreviousPage() {
	const location = useLocation();

	return (location.state as any)?.prev_page as PrevPage;
}
